import {ReactElement} from 'react'
import {useState} from 'react'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Modal, Header, Body, Footer} from '@freckle/educator-materials/ts/components/modal'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {useQueryParamAsBoolean, useRemoveQueryParam} from '@freckle/classroom/ts/hooks/use-params'

type Props = {
  shareError: boolean
  errorType?: 'generalError' | 'subjectNotAvailable'
  children: ReactElement
}

export function ShareAssignmentErrorModalWrapper({shareError, errorType, children}: Props) {
  const share = useQueryParamAsBoolean('share')
  const [showShareError, setShowShareError] = useState(share && shareError)
  const removeShareQueryParam = useRemoveQueryParam('share')

  return (
    <>
      <ShareAssignmentErrorModal
        showModal={showShareError}
        closeModal={() => {
          setShowShareError(false)
          removeShareQueryParam()
        }}
        errorType={errorType ?? 'generalError'}
      />
      {children}
    </>
  )
}

type ErrorModalProps = {
  showModal: boolean
  closeModal: () => void
  errorType: 'generalError' | 'subjectNotAvailable'
}

function ShareAssignmentErrorModal({showModal, closeModal, errorType}: ErrorModalProps) {
  const {t} = useSafeTranslation()

  return (
    <Modal show={showModal} onHide={closeModal} height="small">
      <Header onClickClose={closeModal}>{t('THERES_BEEN_AN_ERROR')}</Header>
      <Body>
        <Text style="body-2">
          {errorType === 'subjectNotAvailable'
            ? t('SUBJECT_NOT_AVAILABLE')
            : t('ASSIGNMENT_SHARE_LINK_ERROR')}
        </Text>
      </Body>
      <Footer>
        <Button onClick={closeModal}>{t('OK')}</Button>
      </Footer>
    </Modal>
  )
}
